import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "../../../api/axiosConfig";
import _ from "lodash";
import * as idb from '../../../functions/databaseService/indexedDB';
import signOut from "../../../functions/userIdentity/signOut";

// Action Types
export const FIREBASE_GET_LATEST_TASK_FILE_SUCCESS = "FIREBASE_GET_LATEST_TASK_FILE_SUCCESS";
export const FIREBASE_GET_LATEST_TASK_FILE_ERROR = "FIREBASE_GET_LATEST_TASK_FILE_ERROR";

// Thunk Action Creator
export const getLatestTaskListNoCache = createAsyncThunk(
    "api/Task/latestTaskListNoCache",
    async (_, { dispatch }) => {
        try {

            const online = navigator.onLine;
            if (online) {
                const response = await axios.put(

                    `${import.meta.env.VITE_PUBLIC_DOMAIN}Task/latestTaskListNoCache`,
                    {
                        headers: {
                            "Content-Type": "application/json",
                        },
                    }
                );

                //Check for response 
                //Store API result into indexed DB
                if (response.status == 200) {
                    if (response.data === '') {
                        throw new Error("The last task has not been saved. Logging the user out");
                    } else {
                        idb.storeTaskList(response.data.tasks || response.data);
                    }
                }

                //Dispatch Indexed DB instead of Axios result
                dispatch({
                    type: FIREBASE_GET_LATEST_TASK_FILE_SUCCESS,
                    payload: response.data
                });
            }
            else {
                //get data from indexed DB
                const taskListData = await idb.getTasks();
                if (taskListData) {
                    //Dispatch Indexed DB instead of Axios result
                    dispatch({
                        type: FIREBASE_GET_LATEST_TASK_FILE_SUCCESS,
                        payload: taskListData
                    });
                }
                else {
                    console.log("No tasks found in IndexedDB");
                }
            }
        }
        catch (error) {
            dispatch({ type: FIREBASE_GET_LATEST_TASK_FILE_ERROR, payload: error });
            await signOut();
        }
    }
);